export default __webpack_public_path__ + "static/media/public.31ffbd94.jpg";